module.exports = __webpack_public_path__ + "img/web-push2-sm.80ab23a0.svg";